<template>
    <div class="customer">
        <div class="title">
            <p>服务客户</p>
            <p>Customer service</p>
        </div>
        <div class="allImgs">
            <swiper class="swiper" ref="mySwipers" :options="swiperOption" >
                <swiper-slide class="item" v-for="(item,index) in list" :key="index">
                    <div class="one">
                        <img :src="`http://cs.sansg.com/${item.picurl}`" alt="">
                    </div>
                </swiper-slide>
            </swiper>
            <div class="btn prev ">
                <i class="el-icon-arrow-left"></i>
            </div>
            <div class="btn next ">
                <i class="el-icon-arrow-right"></i>
            </div>
        </div>
    </div>
</template>

<script>
    import { swiper, swiperSlide } from "vue-awesome-swiper";
    import "swiper/dist/css/swiper.css";
    import { getProductsUrl} from '../util/lang'
    export default {
        name: "customer",
        data(){
            return{
                list:[],
                swiperOption:{
                    notNextTick: true,
                    slidesPerView: 5,
                    speed:1000,
                    init:false,
                    loop:true,
                    spaceBetween :5,
                    autoplay: false,
                    setWrapperSize :true,
                    navigation: {
                        prevEl: '.allImgs .btn.prev',
                        nextEl: '.allImgs .btn.next',
                    }
                },
            }
        },
        components:{swiper, swiperSlide},
        mounted(){
            setTimeout(()=>{
                this.getList('2')
            },100)
        },
        methods:{
            getList(id){
                const url = `${getProductsUrl(id)}`
                this.$axios.get(url).then(res => {
                    this.list=res.data.data
                    setTimeout(()=>{
                        this.$refs.mySwipers.swiper.init()
                    },100)
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.customer{
    width:1440px;
    margin: 60px auto;
    animation-duration: 3s;
    .title{
        width:100%;
        p:nth-child(1){
            color:#8D8D8D;
            font-family: "SOURCEHANSANSCN-HEAVY.OTF";
            font-size: 20px;
        }
        p:nth-child(2){
            color:#084CAD;
            font-family: "Oswald-Stencil.otf";
            font-size: 35px;
            line-height: 50px;
        }
    }
    .allImgs{
        width:100%;
        margin: 120px auto;
        position: relative;
        .swiper{
            width:90%;
            margin-left: 0;
            .item{
                .one{
                    width:90%;
                    border:1px solid rgba(223,223,223,1);
                    border-radius:5px;
                    text-align: center;
                    cursor: pointer;
                    overflow: hidden;
                    height:113px;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: center;
                    img{
                        transition: all 600ms;
                        display: block;
                    }
                    &:hover{
                        img{
                            transform: scale(1.05);
                        }
                    }
                }
            }
        }
        .prev{
            position: absolute;
           right:0;
            top:22%;
            padding:5px 5px;
            color:white;
            background-color: #cccccc;
            cursor: pointer;
            transition: all 1s;
            height:30px;
            width:30px;
            z-index: 1000;
            text-align: center;
            line-height: 30px;
            i{
                font-size:16px;
            }
        }
        .next{
            position: absolute;
            right:-35px;
            top:22%;
            padding:5px 5px;
            color:white;
            background-color: #cccccc;
            cursor: pointer;
            transition: all 1s;
            height:30px;
            width:30px;
            z-index: 1000;
            text-align: center;
            line-height: 30px;
            i{
                font-size:16px;
            }
        }
        .btn:hover{
            color:#0069FF;
            border-color: #0069FF;
        }
        .btn:focus{
            outline: none;
        }
    }
    @media screen and (max-width: 1440px) and (min-width: 1000px){
        width:90%;
    }
}
</style>
